module.exports = __webpack_public_path__ + "static/media/icon_menu_display.ff67924d.svg";